module.exports = __webpack_public_path__ + "static/media/cyprus-green.828cb90f.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/apple-watch/silver-aluminum-case/cyprus-green.jpeg
// module id = 2043
// module chunks = 0